import { oidcConfig } from 'core/utils/auth-provider-config';
import { AuthProvider } from 'oidc-react';
import React from 'react';

const POST_LOGIN_REDIRECT_KEY = 'post_login_redirect';

export const OidcAuthProvider: React.FC<React.PropsWithChildren> = ({ children }) => (
    <AuthProvider
        {...oidcConfig}
        redirectUri={globalThis.location.origin}
        onBeforeSignIn={() => {
            const currentPath = globalThis.location.pathname + globalThis.location.search;
            sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, currentPath);
        }}
        onSignIn={() => {
            const redirectPath = sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY);
            sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
            if (redirectPath && redirectPath !== '/') {
                globalThis.location.replace(redirectPath);
            }
        }}
    >
        {children}
    </AuthProvider>
);
